import mapIconMapping from '../../utils/mapIconTitles';

const ColorMapping = Object.fromEntries(
    Object.entries(mapIconMapping).map(([key, { color }]) => [key, color])
);

export default ColorMapping;
